
import {Component, Prop, Vue} from 'vue-property-decorator';
import {IServicesGenCommand} from '@/services/dto/IServicesGenCommand';

@Component({})
export default class FbVisioSigIconOrderState extends Vue {
  @Prop() private services?: IServicesGenCommand;
}
